/**
 * Create a promise that will resolve after a specified number of milliseconds.
 *
 * @param ms The number of milliseconds the promise will resolve after.
 * @return A promise.
 */
export function delay(ms = 0) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}
